/* =============================================
   NO VANITY — MAIN JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ================================================================
  // HEADER LOGO — fires immediately on load, clean one-time entrance
  // ================================================================
  const siteHeader = document.querySelector('.site-header');

  (function triggerHeaderEntrance() {
    if (!siteHeader) return;
    const logoEl = siteHeader.querySelector('.site-header__logo img, .site-header__logo--text');
    if (!logoEl) return;
    // No delay — fires as soon as DOM is ready
    logoEl.classList.add('roll-in');
    logoEl.addEventListener('animationend', () => {
      logoEl.classList.remove('roll-in');
      logoEl.classList.add('roll-settled');
    }, { once: true });
  })();

  // ================================================================
  // EMAIL POPUP — shows after delay, remembers dismissal
  // ================================================================
  const emailPopupOverlay = document.getElementById('email-popup-overlay');

  if (emailPopupOverlay) {
    const popupClose = document.getElementById('email-popup-close');
    const popupDismiss = document.getElementById('email-popup-dismiss');
    const popupForm = document.getElementById('email-popup-form');

    const STORAGE_KEY = 'nv_email_popup_dismissed_until';
    const delaySeconds = parseInt(emailPopupOverlay.dataset.delay || '3', 10);
    const reappearDays = parseInt(emailPopupOverlay.dataset.reappear || '7', 10);

    function shouldShowPopup() {
      try {
        const dismissedUntil = localStorage.getItem(STORAGE_KEY);
        if (!dismissedUntil) return true;
        return Date.now() > parseInt(dismissedUntil, 10);
      } catch (e) {
        return true;
      }
    }

    function openPopup() {
      emailPopupOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closePopup(remember) {
      emailPopupOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (remember) {
        try {
          const until = Date.now() + reappearDays * 24 * 60 * 60 * 1000;
          localStorage.setItem(STORAGE_KEY, until.toString());
        } catch (e) { /* localStorage unavailable */ }
      }
    }

    if (shouldShowPopup()) {
      setTimeout(openPopup, delaySeconds * 1000);
    }

    if (popupClose) popupClose.addEventListener('click', () => closePopup(true));
    if (popupDismiss) popupDismiss.addEventListener('click', () => closePopup(true));

    emailPopupOverlay.addEventListener('click', (e) => {
      if (e.target === emailPopupOverlay) closePopup(true);
    });

    // If they submit the form successfully, don't show again for a long time
    if (popupForm) {
      popupForm.addEventListener('submit', () => {
        try {
          const until = Date.now() + 365 * 24 * 60 * 60 * 1000;
          localStorage.setItem(STORAGE_KEY, until.toString());
        } catch (e) { /* ignore */ }
      });
    }
  }

  // ================================================================
  // COOKIE CONSENT BANNER
  // ================================================================
  const cookieBanner = document.getElementById('cookie-banner');

  if (cookieBanner) {
    const COOKIE_KEY = 'nv_cookie_consent';
    const acceptBtn = document.getElementById('cookie-accept');
    const declineBtn = document.getElementById('cookie-decline');

    function getCookieConsent() {
      try {
        return localStorage.getItem(COOKIE_KEY);
      } catch (e) {
        return null;
      }
    }

    function setCookieConsent(value) {
      try {
        localStorage.setItem(COOKIE_KEY, value);
      } catch (e) { /* ignore */ }
    }

    if (!getCookieConsent()) {
      setTimeout(() => cookieBanner.classList.add('is-visible'), 600);
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', () => {
        setCookieConsent('accepted');
        cookieBanner.classList.remove('is-visible');
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', () => {
        setCookieConsent('declined');
        cookieBanner.classList.remove('is-visible');
      });
    }
  }

  // ================================================================
  // QUICK ADD MODAL
  // ================================================================
  const quickAddOverlay = document.getElementById('quick-add-overlay');
  const quickAddClose = document.getElementById('quick-add-close');
  const quickAddImage = document.getElementById('quick-add-image');
  const quickAddTitle = document.getElementById('quick-add-title');
  const quickAddPrice = document.getElementById('quick-add-price');
  const quickAddSizes = document.getElementById('quick-add-sizes');
  const quickAddSubmit = document.getElementById('quick-add-submit');
  const quickAddFeedback = document.getElementById('quick-add-feedback');

  let currentQuickAddVariant = null;

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function openQuickAdd(handle) {
    const script = document.querySelector(`script[data-product-json="${handle}"]`);
    if (!script || !quickAddOverlay) return;

    let data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    quickAddImage.src = data.image || '';
    quickAddImage.alt = data.title;
    quickAddTitle.textContent = data.title;
    quickAddPrice.textContent = formatMoney(data.price);
    quickAddSizes.innerHTML = '';
    quickAddFeedback.classList.remove('is-visible');
    quickAddSubmit.style.display = 'block';
    currentQuickAddVariant = null;

    if (data.variants && data.variants.length > 1) {
      data.variants.forEach(variant => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-btn' + (variant.available ? '' : ' sold-out');
        btn.textContent = variant.title;
        btn.dataset.variantId = variant.id;
        if (variant.available) {
          btn.addEventListener('click', () => {
            quickAddSizes.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            currentQuickAddVariant = variant.id;
          });
        }
        quickAddSizes.appendChild(btn);
      });
    } else if (data.variants && data.variants.length === 1) {
      currentQuickAddVariant = data.variants[0].id;
    }

    quickAddOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickAdd() {
    if (!quickAddOverlay) return;
    quickAddOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-add]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openQuickAdd(trigger.dataset.productHandle);
    }
  });

  if (quickAddClose) quickAddClose.addEventListener('click', closeQuickAdd);
  if (quickAddOverlay) {
    quickAddOverlay.addEventListener('click', (e) => {
      if (e.target === quickAddOverlay) closeQuickAdd();
    });
  }

  if (quickAddSubmit) {
    quickAddSubmit.addEventListener('click', async () => {
      if (!currentQuickAddVariant) {
        quickAddSizes.querySelectorAll('.size-btn').forEach(b => b.style.borderColor = 'var(--color-accent)');
        return;
      }
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentQuickAddVariant, quantity: 1 })
        });
        quickAddFeedback.classList.add('is-visible');
        quickAddSubmit.style.display = 'none';
        updateCartCountGlobal();
        setTimeout(() => {
          closeQuickAdd();
          openCartGlobal();
        }, 700);
      } catch (err) {
        console.error(err);
      }
    });
  }

  // Shared helpers used by both quick-add and main cart logic
  async function updateCartCountGlobal() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) { console.error(err); }
  }

  function openCartGlobal() {
    const overlay = document.getElementById('cart-overlay');
    if (overlay) {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  // ================================================================
  // WISHLIST / SAVE FOR LATER — localStorage based
  // ================================================================
  const WISHLIST_KEY = 'nv_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) { /* ignore */ }
  }

  function isWishlisted(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    let list = getWishlist();
    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
    } else {
      list.push(handle);
    }
    setWishlist(list);
    return list.includes(handle);
  }

  function refreshWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      btn.classList.toggle('is-saved', isWishlisted(handle));
    });
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.productHandle;
    const saved = toggleWishlist(handle);
    btn.classList.toggle('is-saved', saved);
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    // If unliking from the wishlist page itself, remove the card
    if (!saved) {
      const grid = document.getElementById('wishlist-grid');
      if (grid && grid.contains(btn)) {
        const card = btn.closest('.product-card');
        if (card) card.remove();
        if (grid.children.length === 0) {
          const empty = document.getElementById('wishlist-empty');
          if (empty) empty.style.display = 'block';
        }
      }
    }
  });

  refreshWishlistButtons();

  // ================================================================
  // NOTIFY ME — sold out size restock capture (product page)
  // ================================================================
  const notifyForm = document.getElementById('notify-form');
  const notifyFormBody = document.getElementById('notify-form-body');
  const productTitleEl = document.querySelector('.product-info__title');

  if (notifyForm) {
    document.querySelectorAll('.size-options .size-btn.sold-out').forEach(btn => {
      btn.addEventListener('click', () => {
        const size = btn.dataset.size || btn.textContent.trim();
        const title = productTitleEl ? productTitleEl.textContent.trim() : '';
        if (notifyFormBody) {
          notifyFormBody.value = `Restock request: ${title} — Size ${size}`;
        }
        notifyForm.style.display = 'block';
        notifyForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  // ================================================================
  // WISHLIST PAGE — fetch and render saved products
  // ================================================================
  const wishlistGrid = document.getElementById('wishlist-grid');
  const wishlistEmpty = document.getElementById('wishlist-empty');

  if (wishlistGrid) {
    const savedHandles = getWishlist();

    if (savedHandles.length === 0) {
      if (wishlistEmpty) wishlistEmpty.style.display = 'block';
    } else {
      Promise.all(
        savedHandles.map(handle =>
          fetch(`/products/${handle}.js`).then(res => res.ok ? res.json() : null).catch(() => null)
        )
      ).then(products => {
        const valid = products.filter(p => p !== null);
        if (valid.length === 0) {
          if (wishlistEmpty) wishlistEmpty.style.display = 'block';
          return;
        }
        valid.forEach(product => {
          const card = document.createElement('div');
          card.className = 'product-card product-card--duo';
          card.setAttribute('data-float-item', '');

          const image = product.featured_image ? product.featured_image : (product.images[0] || '');
          const price = formatMoney(product.price);
          const compareAt = product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : null;

          card.innerHTML = `
            <a href="${product.url}" class="product-card__image-wrap" aria-label="${product.title}">
              <img src="${image}" alt="${product.title}" class="product-card__image" loading="lazy">
            </a>
            <button type="button" class="product-card__wishlist is-saved" data-wishlist-toggle data-product-handle="${product.handle}" aria-label="Remove from wishlist">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
            </button>
            <div class="product-card__info">
              <a href="${product.url}" class="product-card__title">${product.title}</a>
              <p class="product-card__price">${compareAt ? `<s>${compareAt}</s>` : ''}${price}</p>
            </div>
          `;
          wishlistGrid.appendChild(card);
        });

        slideObserver && document.querySelectorAll('#wishlist-grid [data-float-item]').forEach(el => slideObserver.observe(el));
      });
    }
  }

  // ================================================================
  // COUNTDOWN TO DROP
  // ================================================================
  const countdownSection = document.getElementById('countdown-section');

  if (countdownSection) {
    const targetDate = new Date(countdownSection.dataset.target).getTime();
    const daysEl = document.getElementById('countdown-days');
    const hoursEl = document.getElementById('countdown-hours');
    const minutesEl = document.getElementById('countdown-minutes');
    const secondsEl = document.getElementById('countdown-seconds');

    function pad(n) {
      return n.toString().padStart(2, '0');
    }

    let countdownInterval;

    function updateCountdown() {
      const now = Date.now();
      const diff = targetDate - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        if (countdownInterval) clearInterval(countdownInterval);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

  // ---- CART DRAWER ----
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');
  const cartTrigger = document.getElementById('cart-trigger');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) {
    cartOverlay.addEventListener('click', (e) => {
      if (e.target === cartOverlay || e.target.classList.contains('cart-overlay')) {
        closeCart();
      }
    });
  }

  // ---- QTY BUTTONS ----
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.qty-btn, .cart-item__remove');
    if (!btn) return;
    const id = btn.dataset.id;
    const qty = parseInt(btn.dataset.qty, 10);
    if (!id) return;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
    }
  });

  // ---- ADD TO CART ----
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      const variantId = formData.get('id');
      if (!variantId) return;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        openCart();
        updateCartCount();
      } catch (err) {
        console.error(err);
      }
    });
  }

  // ---- UPDATE CART COUNT ----
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) {
      console.error(err);
    }
  }

  // ---- SIZE SELECTOR ----
  const sizeBtns = document.querySelectorAll('.size-btn');
  const variantInput = document.getElementById('variant-id');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('sold-out')) return;
      sizeBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (variantInput) variantInput.value = btn.dataset.variant;
    });
  });

  // ---- MOBILE NAV ----
  const navToggle = document.getElementById('nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavClose = document.getElementById('mobile-nav-close');

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', () => {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // ---- PRODUCT GALLERY THUMBNAILS ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.getElementById('gallery-main');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) mainImage.src = thumb.src.replace('_80x80', '_800x');
    });
  });

  // ================================================================
  // SLIDE SYSTEM
  // Scroll down → elements slide UP into view
  // Scroll up  → elements slide DOWN out of view, then slide UP again on re-entry
  // ================================================================

  // Track scroll direction in real time
  let scrollDir = 'down';
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    scrollDir = window.scrollY > lastScrollY ? 'down' : 'up';
    lastScrollY = window.scrollY;
  }, { passive: true });

  function slideIn(el, delay) {
    el.classList.remove('roll-out-up', 'roll-out-down', 'roll-in', 'roll-settled');
    void el.offsetWidth;
    if (delay) el.style.animationDelay = `${delay}ms`;
    el.classList.add('roll-in');
    el.addEventListener('animationend', () => {
      el.classList.remove('roll-in');
      el.classList.add('roll-settled');
      el.style.animationDelay = '';
    }, { once: true });
  }

  function slideOut(el, exitDir) {
    el.classList.remove('roll-in', 'roll-settled');
    void el.offsetWidth;
    // Exiting top = scrolled past going down → slide up out
    // Exiting bottom = scrolled back up → slide down out
    const cls = exitDir === 'top' ? 'roll-out-up' : 'roll-out-down';
    el.classList.add(cls);
    el.addEventListener('animationend', () => {
      el.classList.remove(cls);
    }, { once: true });
  }

  const slideObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      if (entry.isIntersecting) {
        const siblings = [...(el.parentElement?.querySelectorAll('[data-float-item]') || [])];
        const idx = siblings.indexOf(el);
        const delay = Math.min(idx * 60, 240);
        slideIn(el, delay);
      } else {
        const rect = entry.boundingClientRect;
        // rect.top < 0 means element exited above viewport (scrolled past)
        slideOut(el, rect.top < 0 ? 'top' : 'bottom');
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-float-item]').forEach(el => slideObserver.observe(el));

  // ================================================================
  // HERO SPLASH LOGO — slides in on load, in/out with the section
  // ================================================================
  const splashLogo = document.getElementById('hero-logo');

  function splashSlideIn() {
    if (!splashLogo) return;
    splashLogo.classList.remove('roll-out-up', 'roll-out-down', 'roll-in', 'roll-settled');
    void splashLogo.offsetWidth;
    splashLogo.classList.add('roll-in');
    splashLogo.addEventListener('animationend', () => {
      splashLogo.classList.remove('roll-in');
      splashLogo.classList.add('roll-settled');
    }, { once: true });
  }

  // Fire immediately on load — no delay
  splashSlideIn();

  const heroSection = document.querySelector('.hero-splash');
  if (heroSection) {
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          splashSlideIn();
        } else {
          if (!splashLogo) return;
          const rect = entry.boundingClientRect;
          slideOut(splashLogo, rect.top < 0 ? 'top' : 'bottom');
        }
      });
    }, { threshold: 0.1 });
    heroObserver.observe(heroSection);
  }

  // ---- EMAIL FORM ----
  const emailForm = document.getElementById('email-signup-form');
  if (emailForm) {
    emailForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = emailForm.querySelector('input[type="email"]');
      if (!input || !input.value) return;
      emailForm.innerHTML = '<p style="font-family:var(--font-condensed);letter-spacing:0.15em;font-size:0.85rem;color:var(--color-accent)">YOU\'RE IN. ✓</p>';
    });
  }

  // ---- CLOSE CART ON ESCAPE ----
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      if (mobileNav) {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

});
